import { memo } from 'react';
import { Box, Skeleton, Text } from '@bonanza-social/moonlight';
import { DailyGift } from '@bonanza-social/daily-gift';
import { useSelector } from '@bonanza-social/toolkit/state';
import { isUserOnBreak } from '@bonanza-social/account';

import { selectDailyRewardsDataState } from '@bonanza-social/daily-rewards/state';

function DailyGiftSection() {
  const isUserTimedOut = useSelector(isUserOnBreak);
  const dailyGiftDataState = useSelector(selectDailyRewardsDataState);

  if (dailyGiftDataState === 'pending') {
    return <Skeleton height={148} />;
  }

  if (isUserTimedOut) return null;

  return (
    <Box
      flex={1}
      marginTop="space-400"
      paddingHorizontal="space-400"
      gap="space-200"
    >
      <Text
        variant="h6"
        locNS="rewards"
        locKey="yourDailyGift"
        gradient="darkSurfaceAccent"
      />
      <Box
        variant="gradient"
        gradient="accentBackground"
        padding="space-800"
        borderRadius="radius-200"
        flex={1}
      >
        <DailyGift />
      </Box>
    </Box>
  );
}

export default memo(DailyGiftSection);
